import { createReducer } from 'reduxsauce';
import { Types } from './types';
import { INITIAL_STATE } from './initialState';

export const payoutsStart = state => ({
  ...state,
  isLoading: true,
  error: null,
});

export const payoutsSuccess = (state, { data }) => ({
  ...state,
  data,
  isLoading: false,
});

export const payoutsError = (state, { error }) => ({
  ...state,
  error,
  isLoading: false,
});

export const payoutsCleanUp = () => INITIAL_STATE;

export const HANDLERS = {
  [Types.PAYOUTS_START]: payoutsStart,
  [Types.PAYOUTS_SUCCESS]: payoutsSuccess,
  [Types.PAYOUTS_ERROR]: payoutsError,
  [Types.PAYOUTS_CLEAN_UP]: payoutsCleanUp,
};

export default createReducer(INITIAL_STATE, HANDLERS);
